import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	AppThemeColor,
	BreakpointWidth,
} from '@app/enumerations';
// Import services.
import {
	StylesService,
} from '@app/services';
// Import props.
import {
	FormPopupProps,
} from '@app/props';

const useStyles = makeStyles((theme: Theme) => {

	const getThemeTypeColor = (props: FormPopupProps) => {
		return StylesService.getInstance().getThemeColor(theme, props.themeType ?? AppThemeColor.PRIMARY);
	};

	const getThemeTypeContrastText = (props: FormPopupProps) => {
		return StylesService.getInstance().getThemeColorContrastText(theme, props.themeType ?? AppThemeColor.PRIMARY);
	};

	return createStyles({
		formPopup_header: {
			display: 'flex',
			background: getThemeTypeColor,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(2, 3),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(1.5, 3),
			},
		},
		formPopup_headerLeft: {
			display: 'flex',
			flex: '1 0',
		},
		formPopup_headerRight: {
			display: 'inline-flex',
			justifyContent: 'flex-end',
			flexWrap: 'wrap',
			flex: '0 0 auto',
		},
		formPopup_headerTitle: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h5.fontSize,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h6.fontSize,
			},
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			height: '100%',
			color: getThemeTypeContrastText,
		},
		formPopup_sideIcon: {
			color: getThemeTypeContrastText,
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				marginLeft: theme.spacing(1.5),
				padding: theme.spacing(0),
			},
		},
		formPopup_bodyWrapper: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(2, 3),
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(3),
			},
		},
		formPopup_footerWrapperFixed: {
			padding: theme.spacing(0, 3, 2, 3),
		},
		formPopup_footerWrapper: {
			padding: theme.spacing(0, 3, 2, 3),
		},
		formPopup_absentFooter: {
			height: theme.spacing(2),
		},
		formPopup_headerIconWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginRight: theme.spacing(2),
		},
		formPopup_headerIcon: {
			fontSize: theme.typography.h4.fontSize,
			color: getThemeTypeContrastText,
		},
	});
});

export default useStyles;
